<template lang="pug">
div
    label(:class="fieldNotEmptyClass") {{ fieldLabel }}
    v-select-extended(
              v-model="parentsMutableValue",
              :filterable="false",
              :options="options",
              :searchable="searchable",
              :multiple="multiple",
              :on-search="onSearch",
              :clearSearchOnSelect="clearSearchOnSelect",
              :label="label",
              :onChange="onChange",
              :inputId="inputId",
              :maxHeight="maxHeight",
              :fieldState="fieldState",
              ref="v-select-extended",
              :disabled="disabled",
              v-on:search-empty="searchEmpty",
              :clearable="clearable",
              :withPreloading="withPreloading",
              @focus="$emit('focus')",
              @blur="$emit('blur')")
        span(slot="no-options") {{ noOptionsText }}
    .field-underline(:class="fieldActiveClass")
</template>

<script>
import vSelect from 'vue-select';

let vSelectExtended = {
    extends: vSelect,
    props: {
        fieldState: Object,
        clearable: Boolean,
        withPreloading: Boolean,
        ...vSelect.props
    },
    created() {
        let me = this;

        let onSearchFocus = this.onSearchFocus;
        let onSearchBlur = this.onSearchBlur;

        me.onSearchFocus = function(e) {
            if (me._searchEmpty && me.withPreloading) {
                me.onSearch(me.search, me.toggleLoading);
            }

            me.fieldState.active = true;
            me.$emit('focus');
            return onSearchFocus(e);
        };
        me.onSearchBlur = function(e) {
            me.fieldState.active = false;
            me.$emit('blur');
            return onSearchBlur(e);
        };

        this._searchEmpty = true;
    },
    watch: {
        value(value) {
            this.fieldState.notEmpty = !!(!this.valueIsEmpty() || this.search);
        },
        search(value) {
            this.fieldState.notEmpty = !!(!this.valueIsEmpty() || this.search);

            if (!this.search && !this._searchEmpty) {
                this._searchEmpty = true;
                this.$emit('search-empty', true);
            } else if (this.search && this._searchEmpty) {
                this._searchEmpty = false;
                this.$emit('search-empty', false);
            }
        }
    },
    computed: {
        showClearButton() {
            if (!this.clearable) return false;
            return !this.multiple && !this.open && this.mutableValue != null;
        }
    },
    methods: {
        valueIsEmpty() {
            if (this.multiple) {
                return !(this.value && this.value.length);
            } else {
                return this.value === null;
            }
        }
    }
};

export default {
    name: 'vSelectStyled',
    components: {vSelectExtended},
    props: {
        fieldLabel: {
            type: String,
            default: ''
        },
        onSearch: Function,
        ...vSelect.props,
        label: {
            type: String,
            default: 'name'
        },
        clearable: {
            type: Boolean,
            default: true
        },
        withPreloading: {
            type: Boolean,
            default: false
        }
        // debounce: {
        //     type: Number,
        //     default: 500
        // }
    },
    created() {
        this.parentsMutableValue = this.value;
    },
    computed: {
        fieldNotEmptyClass() {
            return {
                'vfl-field-not-empty': this.fieldState.active || this.fieldState.notEmpty,
                'vfl-field-z-index': true
            };
        },
        fieldActiveClass() {
            return {
                'vfl-field-active': this.fieldState.active
            };
        }
    },
    watch: {
        value(val) {
            this.parentsMutableValue = val;
        },
        parentsMutableValue(val) {
            this.$emit('input', val);
        }
    },
    methods: {
        searchEmpty(val) {
            this.noOptionsText = this.noOptionsTextChoice[val ? 'empty' : 'notFound'];
        }
    },
    data() {
        let noOptionsTextChoice = {
            empty: 'Начните ввод и сразу чего-нибудь найдем',
            notFound: 'К сожалению, ничего не найдено'
        };

        return {
            parentsMutableValue: null,
            noOptionsTextChoice,
            noOptionsText: noOptionsTextChoice.empty,
            fieldState: {
                notEmpty: this.multiple ? !!(this.value && this.value.length) : !!this.value,
                active: false
            }
        };
    }
};
</script>

<style scoped>
label.vfl-field-z-index {
    z-index: 1;
}

label.vfl-field-not-empty {
    color: var(--field-with-focus-color);
    -webkit-transform: translateX(-10%) translateY(-100%) scale(0.8, 0.8);
    transform: translateX(-10%) translateY(-100%) scale(0.8, 0.8);
}

label {
  color: var(--field-placeholder-color);
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 0px;
  top: 8px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.field-underline.vfl-field-active:before,
.field-underline.vfl-field-active:after {
  width: 50%;
}

</style>


// WEBPACK FOOTER //
// src/components/vSelectStyled.vue